import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function Notes() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();

  return (
    <fieldset>
      <legend>{t("Global notes")}</legend>
      <input
        name="addNote"
        onChange={onChange}
        value={searchObject.addNote || ""}
        className="form-control"
        type="text"
      />
    </fieldset>
  );
}
